import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { GiSave } from "react-icons/gi";
import { phonenumberValid } from "../../../../../helpers/Utils";
import TextInputModal from "../../../../common/TextInputModal";
import { GrClose, GrEdit } from "react-icons/gr";
import { Divs, UlElements } from "../../../../common/StyledComponents";
import {
  postToRivile,
  updateServiceRepairAddress,
} from "../../../../../redux/Actions/Service/serviceAction";
import { LongButton } from "../../../../common/Buttons";
import { ClassicButtonOutline } from "../../../../common/ButtonWithLoading";
import { AiOutlineDownload } from "react-icons/ai";
import SelectInput from "../../../../common/SelectInput";
import useFetch from "../../../../../hooks/useFetch";
import { buildCountriesArray } from "../../../../../helpers/OrdersFunctionsGlobal";

function ServiceRepairAddress({ address, orderId }) {
  const dispatch = useDispatch();
  const [editAddress, setEditAddress] = useState(false);
  const [addressArr, setAddressArr] = useState(address);
  const [rivile, setRivile] = useState({
    success: false,
    error: null,
  });

  const handleChangeText = (e) => {
    const { name, value } = e.target;
    setAddressArr({
      ...addressArr,
      [name]: value,
    });
  };

  const updateOrderAddress = () => {
    let objData = {
      ...address,
      ...addressArr,
    };
    delete objData.valid_phone;

    dispatch(updateServiceRepairAddress(objData.id, objData)).then((res) => {
      if (res.ok) {
        setAddressArr(res.data);
        setEditAddress(false);
      }
    });
  };
  const toggleAddress = () => setEditAddress((prev) => !prev);
  const phonenumber = phonenumberValid(address.phone);

  const postRivile = () => {
    setRivile({ success: "loading", error: rivile.error });
    dispatch(postToRivile(orderId)).then((res) => {
      if (res.success) {
        setRivile({
          success: true,
          error: null,
        });
      } else {
        setRivile({
          success: false,
          error: res.error,
        });
      }
    });
  };

  return (
    <Divs className="mb-3">
      <div className="d-flex justify-content-between font-weight-bold mb-3">
        <span>Address</span>
        <div
          className="d-flex align-items-center"
          style={{ cursor: "pointer" }}
          onClick={() => toggleAddress()}
        >
          {editAddress ? (
            <GrClose title="Atšaukti" />
          ) : (
            <GrEdit title="Redaguoti" />
          )}
        </div>
      </div>
      <UlElements>
        {editAddress ? (
          <AddressForm
            addressArr={addressArr}
            handleChangeText={handleChangeText}
            updateOrderAddress={updateOrderAddress}
          />
        ) : (
          <React.Fragment>
            <li>
              {address.firstname} {address.lastname}
            </li>
            <li>{address.street}</li>
            <li>
              {address.country ? `${address.country.en_name}, ` : ""}
              {address.city}, {address.postal_code}
            </li>
            <li className={phonenumber ? "" : "text-danger"}>
              {address.phone}
            </li>
            <li>{address.other}</li>
            <li>
              {address.registered_in_rivile ? (
                <div className="d-flex">
                  <LongButton
                    style={{
                      backgroundColor: "#28a745",
                      color: "white",
                      fontSize: "12px",
                      maxWidth: "150px",
                      height: "auto",
                      width: "auto",
                      padding: "0 13px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    text={"Exported"}
                  />
                </div>
              ) : (
                <ClassicButtonOutline
                  loading={rivile.success === "loading"}
                  onClick={() => postRivile()}
                >
                  <AiOutlineDownload size={16} />
                  <span>Client</span>
                </ClassicButtonOutline>
              )}
            </li>
            {rivile.error !== null && (
              <li
                className="text-danger d-flex justify-content-end"
                style={{ fontSize: "13px" }}
              >
                {rivile.error.map((item) => (
                  <div>{item}</div>
                ))}
              </li>
            )}
          </React.Fragment>
        )}
      </UlElements>
    </Divs>
  );
}

const AddressForm = ({ addressArr, handleChangeText, updateOrderAddress }) => {
  const { value: countriesData } = useFetch("/api/v1/countries");
  const countries = buildCountriesArray(countriesData?.data);
  return (
    <React.Fragment>
      <li>
        <TextInputModal
          text="First name"
          placeholder="Enter"
          name="firstname"
          value={addressArr.firstname}
          onChange={(e) => handleChangeText(e)}
        />
      </li>
      <li>
        <TextInputModal
          text="Last name"
          placeholder="Enter"
          name="lastname"
          value={addressArr.lastname}
          onChange={(e) => handleChangeText(e)}
        />
      </li>
      <li>
        <SelectInput
          required={true}
          label="Country"
          value={addressArr.country_id || undefined}
          onChange={(value) =>
            handleChangeText({ target: { value, name: "country_id" } })
          }
          options={countries}
        />
      </li>
      <li>
        <TextInputModal
          text="Address"
          placeholder="Enter"
          name="street"
          value={addressArr.street}
          onChange={(e) => handleChangeText(e)}
        />{" "}
      </li>
      <li>
        <TextInputModal
          text="City"
          placeholder="Enter"
          name="city"
          value={addressArr.city}
          onChange={(e) => handleChangeText(e)}
        />{" "}
      </li>
      <li>
        <TextInputModal
          text="Postal code"
          placeholder="Enter"
          name="postal_code"
          value={addressArr.postal_code}
          onChange={(e) => handleChangeText(e)}
        />
      </li>
      <li>
        <TextInputModal
          text="Phone"
          placeholder="Enter"
          name="phone"
          value={addressArr.phone}
          onChange={(e) => handleChangeText(e)}
        />{" "}
      </li>
      <li>
        <TextInputModal
          text="Email"
          placeholder="Enter"
          name="other"
          value={addressArr.other}
          onChange={(e) => handleChangeText(e)}
        />
      </li>

      <li className="my-3">
        <button
          className="btn btn-sm btn-primary"
          style={{ width: "100%" }}
          onClick={() => updateOrderAddress(addressArr)}
        >
          <GiSave />
          {"Update"}
        </button>
      </li>
    </React.Fragment>
  );
};

export default ServiceRepairAddress;
